import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import './AuctionPage.css'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import { isAuthenticated } from '../../Utils/Auth'
import { request } from '../../Utils/Request'
import Timer from '../../Utils/Timer'
import { formatSwedishDateTime } from '../../Utils/common'
import ReactImageGallery from 'react-image-gallery'
import { useTranslation } from 'react-i18next'

const UpcomingAuction = (props) => {
    const [expandedId, setExpandedId] = useState(null)
    const [expandedId2, setExpandedId2] = useState(null)
    const [expandedId3, setExpandedId3] = useState(null)
    const [auctions, setAuctions] = useState([])
    const [lotDetails, setLotDetails] = useState([])
    const [auctionsLoad, setAuctionsLoad] = useState(false)
    const [lotImages, setLotImages] = useState([])
    const [showGallery, setShowGallery] = useState(false)
    const [currentLotId, setCurrentLotId] = useState(null)
    const { t } = useTranslation()

    let auctionid = props.match.params.id
    const history = useHistory()

    const toggleDetails = (id) => {
        setExpandedId(expandedId === id ? null : id)
    }

    const toggleDetails2 = (id) => {
        setExpandedId2(expandedId2 === id ? null : id)
    }

    const toggleDetails3 = (id) => {
        setExpandedId3(expandedId3 === id ? null : id)
    }

    const getAuctionDetails = async (body) => {
        let { data } = await request('post', '/getauctionlotdetails', body)
        console.log('Data -', data)
        setAuctionsLoad(true)
        if (data && data.success) {
            if (data.data) {
                const parsedData = data.data.lot_details.map((item) => {
                    const details = JSON.parse(item?.extra_fields)
                    return {
                        ...item,
                        extra_fields: details,
                    }
                })
                setAuctions(data.data)
                setLotDetails(parsedData)
            } else {
                setAuctions([])
                setLotDetails([])
            }
        }
    }
    useEffect(() => {
        getAuctionDetails({ auctionid, is_carzaar: 1 })
    }, [isAuthenticated(), auctionid])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const hanldeImageOpen = async (id) => {
        let { data } = await request('get', `/getLotImagesByProjectId?projectId=${id}`, {})
        if (data && data.success) {
            console.log('data-', data.data)
            const formattedImages = data.data.map((image) => ({
                h: 900,
                original: `${process.env.REACT_APP_PRODUCT_URL}/${image.file_name}`,
                originalClass: 'popupSlider',
                src: `${process.env.REACT_APP_PRODUCT_URL}/${image.file_name}`,
                thumbnail: `${process.env.REACT_APP_PRODUCT_URL}/${image.file_name}`,
                w: 1200,
            }))
            setLotImages(formattedImages)
            setCurrentLotId(id)
            setShowGallery(true)
        }
    }

    const closeGallery = () => {
        setShowGallery(false)
        setLotImages([])
        setCurrentLotId(null)
    }

    console.log(' Auctions Data-', auctions)
    console.log('lot detais -', lotDetails)
    console.log('lot Images-', lotImages)

    return (
        <div className="live-auction customContainer pt-5">
            <div className="auction-page">
                {auctions ? (
                    <>
                        <div className="auction-header">
                            <div className="auction-info text-left">
                                <div className="d-flex justify-content-start align-items-center">
                                    <span className="mr-2">
                                        <svg
                                            width="23"
                                            height="16"
                                            viewBox="0 0 23 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.53846 16H19.6923C21.0517 16 22.1538 14.8978 22.1538 13.2308V9.53846H9.53846V16ZM19.6923 0H9.53846V6.46154H22.1538V2.46154C22.1538 1.8087 21.8945 1.1826 21.4329 0.720968C20.9712 0.25934 20.3451 0 19.6923 0ZM6.46154 0H2.46154C1.80902 -1.83521e-07 1.1832 0.259086 0.72162 0.720315C0.260045 1.18154 0.000489391 1.80717 0 2.45969L0 6.46154H6.46154V0ZM0 9.53846V13.2332C0.00123077 14.8991 1.10277 16 2.46154 16H6.46154V9.53846H0Z"
                                                fill="#006AA7"
                                            />
                                            <path
                                                d="M9.53846 0H6.46154V6.46154H0V9.53846H6.46154V16H9.53846V9.53846H22.1538V6.46154H9.53846V0Z"
                                                fill="#FECC00"
                                            />
                                        </svg>
                                    </span>
                                    <span className="title">Auction</span>
                                </div>
                                <h2>
                                    {auctions?.auction_details?.title} -{' '}
                                    {auctions?.auction_details?.id}
                                </h2>
                            </div>
                            <div className="auction-timer">
                                <button className="share-button">
                                    <span className="material-icons">share</span>
                                </button>
                                <div className="timer-details">
                                    <p className="time">
                                        <Timer
                                            date_closed={auctions?.auction_details?.date_closed}
                                            date_added={auctions?.auction_details?.date_added}
                                            withText={1}
                                            days={t('days')}
                                            hours={t('hours')}
                                            min={t('mins')}
                                            sec={t('sec')}
                                        />
                                    </p>
                                    <div className="end-time">
                                        <span>{t('ends_on')}</span>:{' '}
                                        {auctions?.auction_details?.date_closed &&
                                            formatSwedishDateTime(
                                                auctions?.auction_details?.date_closed,
                                            )}
                                    </div>
                                </div>
                                <button className="status-button">
                                    {auctions?.auction_details?.market_status}
                                </button>
                            </div>
                        </div>
                        <p className="description">{t('user_cars')}</p>
                        <div className="car-listing-container">
                            {lotDetails.map((car) => (
                                <div key={car.id} className="car-card">
                                    <div className="car-header">
                                        <div className="position-relative">
                                            <img
                                                src={`${process.env.REACT_APP_PRODUCT_URL}/${car.avatar}`}
                                                alt={car.title}
                                                className="car-image"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    history.push(`/product/${car.id}/${car.title}`)
                                                }}
                                            />
                                            <button className="status-button">
                                                {car?.market_status}
                                            </button>
                                            <div
                                                className="cmr"
                                                style={{ cursor: 'pointer', gap: '5px' }}
                                                onClick={() => hanldeImageOpen(car.id)}
                                            >
                                                <svg
                                                    width="14"
                                                    height="13"
                                                    viewBox="0 0 14 13"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M7.11067 8.94449C8.12319 8.94449 8.944 8.12368 8.944 7.11116C8.944 6.09864 8.12319 5.27783 7.11067 5.27783C6.09815 5.27783 5.27734 6.09864 5.27734 7.11116C5.27734 8.12368 6.09815 8.94449 7.11067 8.94449Z"
                                                        stroke="black"
                                                    />
                                                    <path
                                                        d="M5.75321 12H8.46898C10.3763 12 11.3302 12 12.0153 11.5508C12.3109 11.3572 12.5655 11.1072 12.7645 10.8151C13.2222 10.1428 13.2222 9.20601 13.2222 7.33357C13.2222 5.46113 13.2222 4.5243 12.7645 3.85208C12.5655 3.55996 12.3109 3.30994 12.0153 3.1163C11.5753 2.82725 11.024 2.72397 10.1801 2.6873C9.77737 2.6873 9.43087 2.38786 9.35203 1.9998C9.29179 1.71556 9.13526 1.46083 8.90889 1.27866C8.68252 1.0965 8.4002 0.998078 8.10965 1.00003H6.11254C5.50877 1.00003 4.98871 1.41864 4.87016 1.9998C4.79132 2.38786 4.44482 2.6873 4.0421 2.6873C3.19877 2.72397 2.64755 2.82786 2.20694 3.1163C1.91149 3.31 1.65711 3.56002 1.45833 3.85208C1 4.5243 1 5.46052 1 7.33357C1 9.20662 1 10.1422 1.45772 10.8151C1.65572 11.1059 1.90994 11.3559 2.20694 11.5508C2.892 12 3.84594 12 5.75321 12Z"
                                                        stroke="black"
                                                    />
                                                    <path
                                                        d="M11.3885 5.27783H10.7773"
                                                        stroke="black"
                                                        strokeLinecap="round"
                                                    />
                                                </svg>
                                                {car?.attachment_count}
                                            </div>
                                        </div>
                                        <div className="car-info">
                                            <h2
                                                className="car-title"
                                                onClick={() => {
                                                    history.push(`/product/${car.id}/${car.title}`)
                                                }}
                                            >
                                                {car.title}
                                            </h2>
                                            <p className="">
                                                {[
                                                    car.content_head2,
                                                    car?.extra_fields[3]?.regNum,
                                                    car?.extra_fields[3]?.makeType,
                                                    car?.extra_fields[3]?.tradeName,
                                                    car?.extra_fields[3]?.yearModel,
                                                    car?.extra_fields[3]?.fuelType,
                                                    isNaN(car?.extra_fields[3]?.enginePower)
                                                        ? 0
                                                        : `${Math.round(
                                                              car?.extra_fields[3]?.enginePower *
                                                                  1.36,
                                                          )} ${t('engine_power_value')}`,
                                                    car?.extra_fields[3]?.rackvidd != 0 &&
                                                    car?.extra_fields[3]?.rackvidd != 'NA' &&
                                                    typeof car?.extra_fields[3]?.rackvidd !=
                                                        'undefined'
                                                        ? `${car?.extra_fields[3]?.rackvidd} KM`
                                                        : 0,
                                                    car?.extra_fields[3]?.driveTrain,
                                                    car?.extra_fields[3]?.transmission,
                                                ]
                                                    .filter(Boolean) // Filters out falsy values like undefined, null, or empty strings
                                                    .join(' , ')}
                                            </p>

                                            <span className="car-meta">
                                                <span> {`${car.custom_field_4} miles`}</span>
                                                <span>| {car.extra_fields[0]?.vehicleYear}</span>
                                            </span>
                                            <div className="d-flex" style={{ gap: '10px' }}>
                                                <button
                                                    className="details-button"
                                                    onClick={() => toggleDetails(car.id)}
                                                >
                                                    {expandedId === car.id ? (
                                                        <span style={{ color: '#007776' }}>
                                                            {t('details')}
                                                        </span>
                                                    ) : (
                                                        t('details')
                                                    )}
                                                    {expandedId === car.id ? (
                                                        <span
                                                            className="material-icons"
                                                            style={{ color: '#007776' }}
                                                        >
                                                            keyboard_arrow_up
                                                        </span>
                                                    ) : (
                                                        <span className="material-icons">
                                                            keyboard_arrow_down
                                                        </span>
                                                    )}
                                                </button>
                                                <button
                                                    className="details-button"
                                                    onClick={() => toggleDetails2(car.id)}
                                                >
                                                    {expandedId2 === car.id ? (
                                                        <span style={{ color: '#007776' }}>
                                                            {t('equipment')}
                                                        </span>
                                                    ) : (
                                                        t('equipment')
                                                    )}
                                                    {expandedId2 === car.id ? (
                                                        <span
                                                            className="material-icons"
                                                            style={{ color: '#007776' }}
                                                        >
                                                            keyboard_arrow_up
                                                        </span>
                                                    ) : (
                                                        <span className="material-icons">
                                                            keyboard_arrow_down
                                                        </span>
                                                    )}
                                                </button>

                                                <button
                                                    className="details-button"
                                                    onClick={() => toggleDetails3(car.id)}
                                                >
                                                    {expandedId3 === car.id ? (
                                                        <span style={{ color: '#007776' }}>
                                                            {t('damages')}
                                                        </span>
                                                    ) : (
                                                        'Damages'
                                                    )}
                                                    {expandedId3 === car.id ? (
                                                        <span
                                                            className="material-icons"
                                                            style={{ color: '#007776' }}
                                                        >
                                                            keyboard_arrow_up
                                                        </span>
                                                    ) : (
                                                        <span className="material-icons">
                                                            keyboard_arrow_down
                                                        </span>
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                        <div className="timer-details">
                                            <p className="time">
                                                <Timer
                                                    date_closed={car.date_closed}
                                                    date_added={car.date_added}
                                                    withText={1}
                                                    days={t('days')}
                                                    hours={t('hours')}
                                                    min={t('mins')}
                                                    sec={t('sec')}
                                                />
                                            </p>
                                            <div className="end-time">
                                                <span>{t('ends_on')}</span>:{' '}
                                                {formatSwedishDateTime(car.date_closed)}
                                            </div>
                                            <PrimaryButton
                                                customClassName="bidNowBtn"
                                                onClick={() => {
                                                    history.push(`/product/${car.id}/${car.title}`)
                                                }}
                                            >
                                                {t('bid_now')}
                                            </PrimaryButton>
                                        </div>
                                    </div>
                                    {expandedId === car.id && (
                                        <div className="car-details">
                                            <p className="details-item">
                                                <span>{t('vehicle_make')} :</span>
                                                {car?.extra_fields?.[3]?.makeType || ''}
                                            </p>
                                            <p className="details-item">
                                                <span>{t('vehicle_model')} :</span>
                                                {car?.extra_fields?.[3]?.tradeName || ''}
                                            </p>
                                            <p className="details-item">
                                                <span>{t('registration_number')} :</span>
                                                {car?.modelnumber ? car?.modelnumber : '-'}
                                            </p>
                                            <p className="details-item">
                                                <span>{t('model_year')} :</span>
                                                {car?.extra_fields?.[3]?.yearModel || ''}
                                            </p>
                                            <p className="details-item">
                                                <span>{t('fuel_type')} :</span>
                                                {car?.extra_fields?.[3]?.fuelType || ''}
                                            </p>
                                            <p className="details-item">
                                                <span>{t('engine_power')} :</span>
                                                {isNaN(
                                                    Math.round(
                                                        car?.extra_fields?.[3]?.enginePower * 1.36,
                                                    ),
                                                )
                                                    ? 'NA'
                                                    : car?.extra_fields?.[3]?.enginePower != '' &&
                                                      car?.extra_fields?.[3]?.enginePower != 0
                                                    ? `${Math.round(
                                                          car?.extra_fields?.[3]?.enginePower *
                                                              1.36,
                                                      )} ${t('horse_power')}`
                                                    : 'NA'}
                                            </p>
                                            <p className="details-item">
                                                <span>{t('Rackwidd WLTP')} :</span>
                                                {car?.extra_fields?.[3]?.rackvidd != 0 &&
                                                car?.extra_fields?.[3]?.rackvidd != 'NA' &&
                                                typeof car?.extra_fields?.[3]?.rackvidd !=
                                                    'undefined'
                                                    ? `${car?.extra_fields?.[3]?.rackvidd} KM`
                                                    : 'NA'}
                                            </p>

                                            <p className="details-item">
                                                <span>{t('drivetrain')} :</span>
                                                {car?.extra_fields?.[3]?.driveTrain || ''}
                                            </p>
                                            <p className="details-item">
                                                <span>{t('chassis_number')} :</span>
                                                {car?.extra_fields?.[3]?.chassisNumber || ''}
                                            </p>
                                            <p className="details-item">
                                                <span>{t('miles_/_hours')} :</span>
                                                {car?.custom_field_4 || ''}
                                            </p>
                                        </div>
                                    )}

                                    {expandedId2 === car.id && (
                                        <div className="car-details">
                                            <p className="details-item">
                                                <span>{t('car_keys')} :</span>
                                                {car?.content_head1 ? car?.content_head1 : '-'}
                                            </p>
                                            <p className="details-item">
                                                <span>{t('registration_number')} :</span>
                                                {car?.modelnumber ? car?.modelnumber : '-'}
                                            </p>
                                            <p className="details-item">
                                                <span>{t('car_tyres')} :</span>
                                                {car?.content_head2 ? car?.content_head2 : '-'}
                                            </p>
                                            <p className="details-item">
                                                <span>{t('last_maintenance')} :</span>
                                                {car?.content_head3
                                                    ? car?.content_head4 + ' ' + car?.content_head3
                                                    : '-'}
                                            </p>
                                            <p className="details-item">
                                                <span>{t('car_specs')} :</span>
                                                {car?.custom_field_2 ? car?.custom_field_2 : '-'}
                                            </p>
                                        </div>
                                    )}
                                    {expandedId3 === car.id && (
                                        <div className="car-details">
                                            <p className="details-item">
                                                {car?.custom_field_3
                                                    ? car?.custom_field_3
                                                    : 'No records'}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                        {showGallery && (
                            <div
                                className="imageGalleryFull"
                                style={{
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: 'rgba(0,0,0,0.9)',
                                    zIndex: 9999,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                                onClick={closeGallery}
                            >
                                <div
                                    style={{
                                        width: '90%',
                                        maxWidth: '1200px',
                                        position: 'relative',
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <button
                                        onClick={closeGallery}
                                        style={{
                                            position: 'absolute',
                                            top: '-40px',
                                            right: '0',
                                            background: 'white',
                                            border: 'none',
                                            borderRadius: '50%',
                                            width: '30px',
                                            height: '30px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            zIndex: 10000,
                                        }}
                                    >
                                        <span className="material-icons">close</span>
                                    </button>

                                    <ReactImageGallery
                                        items={lotImages}
                                        showFullscreenButton={true}
                                        showPlayButton={false}
                                        lazyLoad={true}
                                        showThumbnails={true}
                                        thumbnailPosition={'bottom'}
                                        slideOnThumbnailOver={false}
                                    />
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <p>No Records Found</p>
                )}
            </div>
        </div>
    )
}

export default UpcomingAuction
